<!--
 * @description: 字典信息
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="dictionaryList"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
    >
      <template v-slot:tabelTitleLeft>
        <div>字典信息列表</div>
      </template>
      <template v-slot:tabelTitleRight>
        <add-button @buttonClick="addPower">新增</add-button>
      </template>
      <template v-slot:condition>
        <text-field
          v-model:value="conditionData.Dic_Id"
          labelText="字典类别:"
          type="select"
          :clearable="true"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.Dic_Text"
          labelText="字典名称:"
          class="condition-container-input"
        >
        </text-field>
      </template>
      <template v-slot:oprator="$opData">
        <div class="opration">
          <div class="style-aaa" @click="delSingleUser($opData.data)">删除</div>
          <!-- <del-border :useConfirm="true" comfirmMessage="确定删除吗？" comfirmOkText="确定" comfirmCancelText="取消"
            @buttonClick="delSingleUser($opData.data)"></del-border> -->
        </div>
      </template>
    </tabel-panel>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import delButton from "@/components/delButton.vue";
import addButton from "@/components/addButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import delBorder from "@/components/delBorder.vue";
import { dictionaryEdit, dictionaryDel } from "@/api/index.js";

import { errMsg, successMsg } from "@/notify/index.js";
import { ElMessageBox } from "element-plus";
export default {
  name: "dictionaryInfo",
  components: {
    delBorder,
    textField,
    addButton,
    delButton,
    tabelPanel,
    popDialog,
    updateButton,
  },
  data() {
    const selectValueFn = (v, item) => {
      if (item) {
        return item.DicId;
      }
    };
    const selectRemoteSearchData = async () => {
      let source = await tableApi.dictionarySelectList();
      if (source.code == 0) {
        let data = source.data.list.map(({ DicId, Name }) => {
          return {
            label: Name,
            value: DicId,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };

    const ProcessRequestSelectValueFn = (v, item) => {
      if (item) {
        return item.ParentId;
      }
    };
    const ProcessRequestSelectData = async (
      pageSize,
      currentPageIndex,
      parms
    ) => {
      if (parms.DicId == null || parms == null) {
        return {
          total: 0,
          data: null,
        };
      }
      // let source = await tableApi.departlistAll({companyId:parms.unitId});

      let source = await tableApi.ProcessRequestSelect({ Dic_Id: parms.DicId });
      if (source.code == 0) {
        let data = source.data.list.map(({ ParentId, ParentDic }) => {
          return {
            label: ParentDic,
            value: ParentId,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(source.message);
      }
    };
    return {
      // 角色名称象管理列表
      // App1: "1"
      // App2: "2"
      // App3: "3"
      // Appendix: "很好"
      // DicId: 1002
      // DicName: "维修全部状态"
      // Dic_Text: "已接受批准"
      // Dic_Value: "已接受批准"
      // IsEnable: true
      // IsRoad: true
      // ParentDic: "超级管理员"
      // ParentId: 7
      // State: true
      // id: 2008

      // 1	Dic_Text 	nvarchar	0	0	是	字典名称
      // 2	Dic_Value	nvarchar	0	0	是	编号
      // 3	Dic_ Id	Int	0	0			是	是	字典类别
      // 4	ParentDic	Int	0	0			是	上级类别
      // 5	State 	bit	1	0				否	是否允许客户使用数据
      // 6	IsEnable 	bit	1	0				否	是否启用
      // 7	IsRoad 	bit	1	0				否	是否有路途时间
      // 8	AddDate 	datetime	8	3	是	添加时间
      // 9	AddUser 	nvarchar	0	0	是	添加人-------
      // 10	Appendix 	nvarchar	0	0	是	备注

      // Appendix: "ZZ"
      // DicId: 1001
      // Dic_Text: "S"
      // Dic_Value: "Z"
      // IsEnable: true
      // IsRoad: true
      // ParentId: 1
      // State: true
      // id: 0

      // 1	Id	int	4	0	是	是		否	字典主键ID
      // 2	App1	nvarchar	0	0	是	货运公司
      // 3	App2	nvarchar	0	0	是
      // 4	App3	nvarchar	0	0	是
      // 5	Dic_Text	nvarchar	0	0				是	字典名称
      // 6	Dic_Value	nvarchar	0	0				是	编号
      // 7	ParentDic	Int	0	0						是	上级类别
      // 8	ParentId	Int	0	0						是	上级类别Id
      // 9	Appendix	nvarchar	0	0				是	备注
      // 10	State	Bit	0	0							否			是否允许客户使用数据
      // 11	IsEnable	bit	0	0						是	是否启用
      // 12	IsRoad	bit	0	0							是	是否有路途时间
      // 13	DicName	nvarchar	0	0					是	字典类别名称
      // 14	DicId	int	4	0							否	字典类别ID

      rowTemplate: [
        {
          headerLabel: "字典类别",
          dataIndex: "DicName",
          requird: true,
          showInDetail: false,
          editType: "text",
          renderToHtml: true,
          sortable: true,
        },
        {
          headerLabel: "字典类别",
          showInList: false,
          editable: true,
          editType: "select",
          selectRemoteSearchData,
          selectValueFn,
          dataIndex: "DicId",
          rules: [
            {
              required: true,
              message: "请输入字典类别",
            },
          ],
        },
        {
          headerLabel: "名称",
          sortable: true,
          editable: true,
          requird: true,
          dataIndex: "Dic_Text",
          rules: [
            {
              required: true,
              message: "请输入字典名称",
            },
          ],
        },
        {
          headerLabel: "上级类别",
          editable: true,
          showInDetail: false,
          dataIndex: "ParentDic",
        },
        {
          headerLabel: "上级类别",
          showInList: false,
          editable: true,
          editType: "select",
          selectRemoteSearchData: ProcessRequestSelectData,
          refKey: "DicId",
          selectValueFn: ProcessRequestSelectValueFn,
          dataIndex: "ParentId",
        },
        {
          headerLabel: "编号",
          editable: true,
          dataIndex: "Dic_Value",
        },
        {
          headerLabel: "是否允许客户使用数据",
          width: 180,
          dataIndex: "State",
          sortable: true,
          showInDetail: true,
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "是否启用",
          dataIndex: "IsEnable",
          sortable: true,
          showInDetail: true,
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          headerLabel: "是否有路途时间",
          dataIndex: "IsRoad",
          showInDetail: true,
          sortable: true,
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
        {
          width: 60,
          headerLabel: "是否允许客户使用数据",
          editable: true,
          editType: "checkbox",
          showInList: false,
          dataIndex: "State",
          fieldData: [
            {
              label: "允许",
              value: true,
            },
          ],
        },
        {
          width: 60,
          headerLabel: "是否启用",
          editable: true,
          showInDetail: true,
          editType: "checkbox",
          showInList: false,
          dataIndex: "IsEnable",
          fieldData: [
            {
              label: "启用",
              value: true,
            },
          ],
        },
        {
          width: 60,
          headerLabel: "是否有路途时间",
          editable: true,
          editType: "checkbox",
          showInList: false,
          dataIndex: "IsRoad",
          fieldData: [
            {
              label: "有路途时间",
              value: true,
            },
          ],
        },
        {
          headerLabel: "备注",
          editable: true,
          editType: "textarea",
          dataIndex: "Appendix",
          rows: 2,
        },
        {
          headerLabel: "操作",
          slot: "oprator",
          width: null,
        },
      ],
      conditionData: {
        Dic_Text: "",
        Dic_Id: "",
      },
    };
  },
  methods: {
    //   获取下拉框改变后的数据
    async selectOuguName() {
      let source = await tableApi.dictionarySelectList({});
      if (source.code == 0) {
        let data = source.data.list.map(({ DicId, Name }) => {
          return {
            label: Name,
            value: DicId,
          };
        });
        let total = 0;

        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },

    // 更新数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    //单列表删除
    delSingleUser({ row }) {
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          dictionaryDel({ Id: row.id }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
      // slotData.ParentId=1
      if (slotData.id === null) {
        slotData.id = 0;
      }
      if (slotData.State == undefined) {
        slotData.State = false;
      }
      if (slotData.IsRoad == undefined) {
        slotData.IsRoad = false;
      }
      if (slotData.IsEnable == undefined) {
        slotData.IsEnable = false;
      }

      slotData.State =
        typeof slotData.State == "boolean" ? slotData.State : slotData.State[0];
      slotData.IsRoad =
        typeof slotData.IsRoad == "boolean"
          ? slotData.IsRoad
          : slotData.IsRoad[0];
      slotData.IsEnable =
        typeof slotData.IsEnable == "boolean"
          ? slotData.IsEnable
          : slotData.IsEnable[0];

      if (slotData.id) {
        // slotData.ParentId = slotData.ParentId || 0
        slotData = JSON.stringify(slotData);
        dictionaryEdit({ data: slotData }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      } else {
        slotData = JSON.stringify(slotData);
        dictionaryEdit({ data: slotData }).then((data) => {
          if (data.code == 0) {
            successMsg(data.message);
            this.reloadData();
            this.$refs.tabel.closeDialog();
          } else {
            errMsg(data.message);
          }
        });
      }
    },
    // 新增
    addPower() {
      this.$refs.tabel.showDialog(null, "新增");
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  // .opration {
  //   height: 100%;
  //   width: 100%;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   align-content: center;

  //   .item {
  //     &:nth-child(n + 1) {
  //       margin-left: 10px;
  //     }
  //   }
  // }

  // .menuPowerBOX {
  //   .el-button--default {
  //     width: 90px;
  //     height: 30px;
  //     color: #ffffff;
  //     background: rgb(100, 134, 232);
  //     border-radius: 4px;
  //   }

  //   .item {
  //     height: 30px;
  //     color: #ffffff !important;
  //     padding: 10px 15px !important;
  //     background: rgb(100, 134, 232) !important;
  //   }
  // }

  // .oprationTree {
  //   height: 300px;
  //   overflow: auto;
  // }

  :deep .pop-dialog-body-data {
    .el-form-item__label {
      margin-top: 10px;
    }
    // background-color: red;
    .el-form-item__label {
      padding-bottom: 0;
    }
  }
}
</style>
